class IBANChecker{
    constructor(ibanCheckers){
        this.ibanCheckers = document.getElementById(ibanCheckers);
        this.init();
    }
    init(){
        if(this.ibanCheckers){

            let reset = this.ibanCheckers.querySelector('#reset');
            let validate = this.ibanCheckers.querySelector('#validate_iban');
            let edit = this.ibanCheckers.querySelector('#edit-submitted-iban-no')
            reset.addEventListener('click',()=>this.clearbox());
            validate.addEventListener('click',()=>this.validate_iban());
            edit.addEventListener('keyup',()=>this.formatIBAN())
            edit.addEventListener('blur',()=>this.formatIBAN())
        }
    }
     trim(stringToTrim) {
        var s = "";
    
        for (var i = 0; i < stringToTrim.length; ++i) {
                if (stringToTrim.charAt(i) != ' ')

                        s += stringToTrim.charAt(i);
            }
    
        return s;
    }
    
     IsAlphaNumeric(str)
    {
        var filter = /^[0-9a-zA-Z]+$/;
        return filter.test(str);
    }
    
     formatIBAN()
    {
        try
        {
            $('#edit-submitted-iban-no').val(extern(this.trim($('#edit-submitted-iban-no').val())));
        }
        catch(e){}
    }
    
     validate_iban()
    {
        // gtagCalculatorIBANChecker();
        $('#iban-answer-error').hide();
        $('#iban-answer').hide();
        
        var adib_account_no = $('#edit-submitted-iban-no').val();
        if(this.trim(adib_account_no)=='')
        {
            $('#iban-answer-error').text(this.ibanCheckers.getAttribute("data-error-accountlength"));
            $('#iban-answer-error').show();
    
        }else {
            var iban_number = this.trim(adib_account_no);
    
            if(iban_number.length==23){
    
                if(!this.IsAlphaNumeric(iban_number)){
                    $('#iban-answer-error').text(this.ibanCheckers.getAttribute("data-error-invalidAccount").replace("{0}", $('#edit-submitted-iban-no').val()));
                    $('#iban-answer-error').show();
                }
                else
                {
                    if(CheckIBAN('edit-submitted-iban-no'))
                    {
                        $('#iban-answer').text(this.ibanCheckers.getAttribute("data-successmsg").replace("{0}", $('#edit-submitted-iban-no').val()));
                        $('#iban-answer').show();
                    }
                    else
                    {
                        $('#iban-answer-error').text(this.ibanCheckers.getAttribute("data-error-invalidAccount").replace("{0}", $('#edit-submitted-iban-no').val()));
                        $('#iban-answer-error').show();
                    }
                }
    
            }else{
                $('#iban-answer-error').text(this.ibanCheckers.getAttribute("data-error-accountlength"));
                $('#iban-answer-error').show();
            }
        }
        return false;
    }
     clearbox(){
        //alert('Hi');
        $('#edit-submitted-iban-no').val("");
        $('.errmsg').html('');
        $('#iban-answer-error').hide();
        $('#iban-answer').hide();
        }
   
}
export default IBANChecker